import ArticleIcon from '@mui/icons-material/Article';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import {
  Alert,
  Box,
  Button,
  Card,
  Container,
  Grid,
  Link,
  Paper,
  Rating,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const BestForm990Software = () => {
  const containerRef = useRef(null);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [removelistener, setRemovelistener] = useState(true);
  const [tempReturn, setTempReturn] = useState(false);
  // Define an array of imported images
  const images = [
    '/assets/images/2290-steps-img.webp',
    '/assets/images/easy-steps-img.webp',
    '/assets/images/941-steps-img.webp',
    // Add more image URLs as needed
  ];
  const Ref = React.useRef<HTMLDivElement>(null);

  // Handle scrolling to change images
  const handleScroll = (event: any) => {
    const delta = event.deltaY;
    if (delta > 0) {
      // Scroll down, show the next imag
      if (currentImageIndex < 2) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else if (delta < 0) {
      // Scroll up, show the previous image
      if (currentImageIndex > 0) {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else {
      setRemovelistener(false);
    }
  };
  function useHorizontalScroll() {
    useEffect(() => {
      const el = Ref.current;
      setTempReturn(tempReturn);
      if (el) {
        const onWheel = (e: any) => {
          if (e.deltaY === 0) return;
          e.preventDefault();
          el.scrollTo({
            behavior: 'smooth',
            top: 0,
            left: 0,
          });
        };

        el.addEventListener('wheel', onWheel);
        if (removelistener === false) {
          el.addEventListener('wheel', onWheel);
        } else if (removelistener === true) {
          el.removeEventListener('wheel', onWheel);
        } else {
          el.addEventListener('wheel', onWheel);
        }
        return () => {
          el.removeEventListener('wheel', onWheel);
        };
      }
      return () => setTempReturn(false);
    }, [removelistener]);
    return Ref;
  }

  const scrollRef = useHorizontalScroll();

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Best Form 990 E-File Software in 2026: Compare Top Providers"
          description="Compare the best IRS Form 990 e-file software in 2026. Evaluate top platforms like TaxZerone on form coverage, error checks, pricing, and ease of use."
          keywords=""
          canonical="comparison/best-form-990-software/"

          // jsonLdPricing="89.99"
          // jsonLdAggregateRatingValue="4.99"
          // jsonLdAggregateRatingCount="3021"
        />
      }
    >
      <Box
        sx={{
          mt: 0,
          pt: 8,
          pb: 8,
          position: 'relative',
          background: `
  linear-gradient(
    180deg,
    #e9eeff 0%,
    #edfaf1 50%,
    #ffffff 100%
  )
`,
          overflow: 'hidden',
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 30,
                  md: 38,
                  lg: 48,
                  xl: 56,
                },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              Best Form 990 Software
              <br />
              Top IRS E-File Solutions Compared
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 20,
                },
                fontWeight: 400,
                mb: 4,
                color: '#5b6472',
                lineHeight: 1.7,
                maxWidth: 950,
                mx: 'auto',
              }}
            >
              Filing Form 990 accurately and on time matters for every
              non-profit tax-exempt status. We compared the leading e-file
              platforms - TaxZerone comes out on top for accuracy, pricing, and
              ease of use.
            </Typography>

            <Stack
              alignItems="center"
              sx={{
                width: '100%',
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                className="btn-primary"
                sx={{
                  backgroundColor: '#1e2f8f',
                  color: '#ffffff',
                  fontWeight: 700,
                  fontSize: 16,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  boxShadow: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover, &:focus, &:active': {
                    backgroundColor: '#16247a',
                    transform: 'scale(1.05)',
                  },
                }}
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=bestform990`}
              >
                Get Started Now
              </Button>

              <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  fontSize: 14,
                  color: '#9aa1ab',
                  fontWeight: 500,
                }}
              >
                No credit card required. Pay only when you file.
              </Typography>
            </Stack>
            {/* 
            <Typography
              sx={{
                mt: 0.5,
                fontSize: 11.5,
                color: '#98a2b3',
                textAlign: 'center',
              }}
            >
              Based on customer reviews
            </Typography> */}
          </Box>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="compare=taxzerone"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Compare TaxZerone{' '}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: 'clamp(18px, 3vw, 38px)',
                  }}
                >
                  vs
                </span>{' '}
                Alternatives
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: {
                    xs: 16,
                    sm: 18,
                    md: 18,
                    lg: 20,
                    xl: 22,
                  },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Ranked by accuracy, coverage, ease of use, and overall value for{' '}
                <br />
                nonprofits and tax-exempt organizations.
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container
          maxWidth="xl"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ px: { xs: 2, md: 3 } }}>
            <Box
              ref={containerRef}
              sx={{
                overflow: 'hidden',
                py: 2,
              }}
            >
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={3}
                sx={{
                  alignItems: 'stretch',
                  justifyContent: 'center',
                  p: 2,
                  maxWidth: '1200px',
                  mx: 'auto',
                }}
              >
                {/* Card 1 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs-form990-org.png"
                        alt="taxzerone vs form990 org"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs Form990.org
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          Filing{' '}
                          <Link
                            href="/nonprofit-taxes/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            990 series
                          </Link>{' '}
                          shouldn't be stressful. TaxZerone makes it simple -
                          built-in error checks, complete form support, and real
                          human help when you need it most.
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="#form990org"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>

                {/* Card 2 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs-990-file990.png"
                        alt="taxzerone vs 990 file990"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs File990
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          Your nonprofit filing, simplified. TaxZerone delivers
                          faster IRS e-file, zero hidden fees, and full 990
                          series support - so you spend less time filing and
                          more time on your mission.
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="#file990"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>

                {/* Card 3 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs-990-simple990.png"
                        alt="taxzerone vs simple990"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs Simple990
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          From 990-N to 990-PF - TaxZerone has you covered. One
                          platform, all forms, unbeatable value. Grow your
                          nonprofit without outgrowing your software.
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="#simple990"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="choose-990-software"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to Choose the Right Form 990 Software
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: 16,
              sm: 18,
              md: 18,
              lg: 20,
              xl: 22,
            },
            fontWeight: 400,
            color: '#333333',
            mb: 3,
            textAlign: 'center',
          }}
        >
          The right Form 990 software doesn't just file - it protects your
          nonprofit's tax-exempt <br />
          status every step of the way.
        </Typography>
        <Container
          maxWidth="lg"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ py: { xs: 2, md: 2 } }}>
            <Grid
              container
              spacing={6}
              justifyContent="center"
              alignItems="stretch"
              sx={{ p: 0 }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#f8e7fb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <TouchAppIcon
                      sx={{
                        color: '#c55ad9',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Ease of Use
                  </Typography>
                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Nonprofit filing shouldn't require a tax degree. The right
                    platform walks you through every 990 section - clean,
                    simple, and built so your organization files confidently
                    every time.
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dff8e8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <ArticleIcon
                      sx={{
                        color: '#2e7d32',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Form Coverage
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Filing just a 990-N? Basic tools may work. Managing 990,
                    990-EZ, or 990-PF across multiple organizations? You need a
                    platform that handles the full 990 series in one place.
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dfe8ff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <FactCheckIcon
                      sx={{
                        color: '#3056d3',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Error prevention
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    One wrong entry can trigger an IRS rejection. Strong
                    validation catches mismatches in EIN, fiscal year, and
                    financials before they ever leave your screen.
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dff9ff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <SupportAgentIcon
                      sx={{
                        color: '#309dd3',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 1.5,
                    }}
                  >
                    Support & Reliability
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Tax deadlines don't wait. Pick a platform that offers real
                    human support and instant IRS status updates - so no 990
                    filing ever goes silent after submission.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                TaxZerone{' '}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: 'clamp(18px, 3vw, 38px)',
                  }}
                >
                  vs
                </span>{' '}
                Traditional Providers
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: {
                    xs: 16,
                    sm: 18,
                    md: 18,
                    lg: 20,
                    xl: 22,
                  },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                See how we compare standard legacy filing platforms.
              </Typography>

              <TableContainer
                sx={{
                  border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 5,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 700,
                      borderCollapse: 'collapse',
                      width: '100%',

                      '& thead': {
                        background: '#0f172a',
                      },

                      '& thead th': {
                        fontSize: {
                          xs: '11px',
                          sm: '12px',
                          md: '13px',
                        },
                        fontWeight: 600,
                        textAlign: 'left',
                        padding: {
                          xs: '10px 8px',
                          sm: '14px 16px',
                          md: '16px 20px',
                        },
                        letterSpacing: '0.08em',

                        whiteSpace: 'nowrap',
                      },

                      '& tbody tr': {
                        transition: 'background-color 0.15s ease',
                      },

                      '& tbody tr:nth-of-type(even)': {
                        backgroundColor: '#f8fafc',
                      },

                      '& tbody td': {
                        fontSize: {
                          xs: '12px',
                          sm: '13.5px',
                          md: '14.5px',
                        },
                        fontWeight: 400,
                        textAlign: 'left',
                        padding: {
                          xs: '10px 8px',
                          sm: '13px 16px',
                          md: '13px 20px',
                        },
                        color: '#1e293b',
                        // borderBottom: '1px solid #e4eaf0',
                        borderBottom: 'none',
                        transition: 'color 0.15s ease',
                      },

                      '& tbody td:first-of-type': {
                        whiteSpace: 'nowrap',
                        fontWeight: 600,
                        color: '#0f172a',
                      },

                      '& tbody tr:last-of-type td': {
                        borderBottom: 'none',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            background: '#fff',
                            borderBottom: 'none',
                            position: 'relative',
                            paddingBottom: '20px',

                            '&::after': {
                              content: '""',
                              position: 'absolute',
                              bottom: 0,
                              left: '50%',
                              transform: 'translateX(-50%)',
                              width: '85%',
                              height: '1.5px',
                              backgroundColor: '#e2e8f0',
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '100%',
                              fontWeight: 700,
                            }}
                          >
                            Feature / Benefit
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{
                            background: '#213e99',
                            textAlign: 'center',
                            color: '#ffffff',
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            borderBottom: '2px solid #213e99',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1,
                              width: '100%',
                            }}
                          >
                            <Typography
                              component="span"
                              sx={{
                                fontSize: { xs: 12, sm: 14, md: 16 },
                                fontWeight: 700,
                                whiteSpace: 'nowrap',
                              }}
                            >
                              TaxZerone
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{
                            background: '#fff',
                            borderBottom: 'none',
                            position: 'relative',
                            paddingBottom: '20px',

                            '&::after': {
                              content: '""',
                              position: 'absolute',
                              bottom: 0,
                              left: '50%',
                              transform: 'translateX(-50%)',
                              width: '85%',
                              height: '1.5px',
                              backgroundColor: '#e2e8f0',
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <Typography
                              component="span"
                              sx={{
                                fontSize: { xs: 12, sm: 14, md: 16 },
                                fontWeight: 700,
                                whiteSpace: 'nowrap',
                                color: '#0f172a', // Matches dark text color from image
                              }}
                            >
                              Legacy Competitors
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <TableRow>
                        <TableCell>Pricing Structure</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Transparent, pay-per-form filing
                        </TableCell>
                        <TableCell>
                          Subscription plans or bundled pricing tiers
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Form Coverage</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Full 990 series -{' '}
                          <Link
                            href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=best-form-990-software`}
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            990-N
                          </Link>
                          ,{' '}
                          <Link
                            sx={{ color: '#0202ff' }}
                            href="/tax-exempt/e-file-irs-form-990-ez/"
                          >
                            990-EZ
                          </Link>
                          ,{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990/"
                            sx={{ color: '#0202ff' }}
                          >
                            990
                          </Link>
                          ,{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990-pf/"
                            sx={{ color: '#0202ff' }}
                          >
                            990-PF
                          </Link>
                          ,{' '}
                          <Link
                            href="/tax-exempt/e-file-irs-form-990-t/"
                            sx={{ color: '#0202ff' }}
                          >
                            990-T
                          </Link>
                          .
                        </TableCell>
                        <TableCell>Limited to select 990 forms only</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Error Validation</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Built-in IRS business rule checks before submission
                        </TableCell>
                        <TableCell>
                          Basic or no pre-submission validation
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>E-Sign</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Secure digital signatures for authorized nonprofit
                          officers (ZeroneVault)
                        </TableCell>
                        <TableCell>
                          Manual signature workflows with extra steps{' '}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Customer Support </TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Free U.S.based support via phone, email, and chat
                        </TableCell>
                        <TableCell>
                          Limited hours or paid support plans
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>IRS Status Updates </TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Instant email notifications on IRS acknowledgment
                        </TableCell>
                        <TableCell>Delayed or manual status tracking</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>User Experience</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Simple dashboard built for nonprofits and tax-exempt
                          organizations
                        </TableCell>
                        <TableCell>
                          Complex workflows requiring multiple steps
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Amendment Filing</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Easy re-filing and corrections at minimal cost
                        </TableCell>
                        <TableCell>
                          Costly or complicated amendment process
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Scalability</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            borderBottom: '2px solid #213e99 !important',
                            fontWeight: 600,
                          }}
                        >
                          Ideal for nonprofits, CPAs, and multi-org filers
                        </TableCell>
                        <TableCell>
                          Better suited for single basic 990-N filers
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Alert
                icon={
                  <InfoOutlinedIcon sx={{ color: '#475569', fontSize: 22 }} />
                }
                sx={{
                  backgroundColor: '#e0f2fe', // Light cyan background matching image
                  color: '#334155', // Soft slate text color
                  fontSize: { xs: '12px', sm: '13px' },
                  lineHeight: 1.5,
                  borderRadius: '12px',
                  padding: '12px 18px',
                  alignItems: 'center',
                  mb: 2,
                  width: '100%',
                  boxShadow: 'none',
                  '& .MuiAlert-icon': {
                    mr: 1.5,
                    padding: 0,
                  },
                  '& .MuiAlert-message': {
                    padding: 0,
                  },
                }}
              >
                <strong> Disclaimer: </strong>
                All feature comparisons reflect information available at the
                time of publishing and may change over time.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="best-form990-providers"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <Box
            sx={{ py: 4, px: { xs: 2, md: 4 }, maxWidth: '1100px', mx: 'auto' }}
          >
            {/* HEADING */}
            <Typography
              variant="h2"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 28,
                  md: 34,
                  lg: 42,
                  xl: 48,
                },
                fontWeight: 600,
                textAlign: 'center',
                mb: 5,
              }}
            >
              Best Form 990 E-File Providers Compared
            </Typography>

            <Stack spacing={4}>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    backgroundColor: '#213e99',
                    color: '#ffffff',
                    p: { xs: 2.5, md: 3 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 600,
                        fontSize: { xs: '20px', md: '24px' },
                      }}
                    >
                      TaxZerone
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best Overall Form 990 Software
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      backgroundColor: '#30E3B2',
                      color: '#044E3A',
                      px: 2.5,
                      py: 0.8,
                      borderRadius: '50px',
                      fontWeight: 700,
                      fontSize: '13px',
                    }}
                  >
                    Recommended
                  </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    TaxZerone is an IRS-authorized e-file provider built for
                    nonprofits of every size. It covers Form 990, 990-EZ, 990-N,
                    and 990-PF with guided, plain-English workflows, built-in
                    error validation, and transparent pay-per-file pricing - no
                    hidden fees or forced subscriptions.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 12 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Covers every 990 form and schedule
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Built-in error checks before submission
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Fast, guided filing in minutes
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Affordable, transparent pricing
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>

                  {/* Best for & CTA Button */}
                  <Typography
                    sx={{
                      color: '#0F172A',
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    <strong>Best for:</strong> All Nonprofits & Tax-Exempt
                    Organizations
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      className="btn-primary"
                      id="tax1099"
                      sx={{
                        mt: 2,
                        px: '20px !important',
                        py: '8px !important',
                        fontSize: '18px !important',

                        transition: 'all 0.3s ease',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.05)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=best-form-990-software`}
                    >
                      Start Filing Now
                    </Button>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  p: { xs: 2.5, sm: 4 },
                }}
              >
                <Typography
                  variant="h3"
                  id="form990org"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: '20px', md: '22px' },
                    color: '#0F172A',
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                >
                  Form990.org
                </Typography>

                <Typography
                  sx={{
                    color: '#64748B',
                    lineHeight: 1.6,
                    fontSize: '14px',
                    mb: 3,
                  }}
                >
                  A long-standing provider covering the full range of 990 forms
                  with solid validation tools. Reliable, but pricing runs higher
                  than TaxZerone for comparable filings.
                </Typography>

                {/* Pros / Cons Table Box */}
                <Grid
                  container
                  sx={{
                    border: '1px solid #E2E8F0',
                    borderRadius: '12px',
                    backgroundColor: '#F8FAFC',
                    overflow: 'hidden',
                  }}
                >
                  {/* Pros */}
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{
                      p: { xs: 2.5, sm: 3 },
                      borderRight: { md: '1px solid #E2E8F0' },
                      borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Pros
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Supports entire Form 990, 990-EZ, and 990-PF series
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Offers robust validation and error-checking tools
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>

                  {/* Cons */}
                  <Grid size={{ xs: 12, md: 6 }} sx={{ p: { xs: 2.5, sm: 3 } }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Cons
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Higher cost per filing
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Interface has a steeper learning curve
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  p: { xs: 2.5, sm: 4 },
                }}
              >
                <Typography
                  id="file990"
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: '20px', md: '22px' },
                    color: '#0F172A',
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                >
                  File990
                </Typography>

                <Typography
                  sx={{
                    color: '#64748B',
                    lineHeight: 1.6,
                    fontSize: '14px',
                    mb: 3,
                  }}
                >
                  A straightforward platform designed for nonprofits with basic
                  annual filing needs. Organizations with more complex reporting
                  requirements may want to explore platforms with broader 990
                  series options.
                </Typography>

                <Grid
                  container
                  sx={{
                    border: '1px solid #E2E8F0',
                    borderRadius: '12px',
                    backgroundColor: '#F8FAFC',
                    overflow: 'hidden',
                  }}
                >
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{
                      p: { xs: 2.5, sm: 3 },
                      borderRight: { md: '1px solid #E2E8F0' },
                      borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Pros
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Clean process for straightforward short-form filings
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Fast setup and onboarding for new users
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }} sx={{ p: { xs: 2.5, sm: 3 } }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Cons
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Interface is less intuitive and feels dated
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Limited coverage for complex schedules or full 990s
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  p: { xs: 2.5, sm: 4 },
                }}
              >
                <Typography
                  variant="h3"
                  id="simple990"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: '20px', md: '22px' },
                    color: '#0F172A',
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                >
                  Simple990
                </Typography>

                <Typography
                  sx={{
                    color: '#64748B',
                    lineHeight: 1.6,
                    fontSize: '14px',
                    mb: 3,
                  }}
                >
                  A lightweight option for small nonprofits filing only 990-N or
                  basic 990-EZ. Easy to use but not built for larger or more
                  complex organizations.
                </Typography>

                <Grid
                  container
                  sx={{
                    border: '1px solid #E2E8F0',
                    borderRadius: '12px',
                    backgroundColor: '#F8FAFC',
                    overflow: 'hidden',
                  }}
                >
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{
                      p: { xs: 2.5, sm: 3 },
                      borderRight: { md: '1px solid #E2E8F0' },
                      borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Pros
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Streamlined for quick 990-N (e-Postcard) completion.
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Highly budget-friendly entry-level pricing
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }} sx={{ p: { xs: 2.5, sm: 3 } }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Cons
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Limited to basic forms; cannot handle full 990 series
                          returns
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Does not support filing amended returns
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="Why-smart-990-filer"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Box
              sx={{
                pt: 6,
                px: 2,
                maxWidth: '1200px',
                mx: 'auto',
                textAlign: 'center',
              }}
            >
              <Box textAlign="center" sx={{ mb: 1 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: {
                      xs: 24,
                      sm: 28,
                      md: 34,
                      lg: 42,
                      xl: 48,
                    },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  Why Smart 990 Filers Are Making the Switch and Staying
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: {
                      xs: 16,
                      sm: 18,
                      md: 18,
                      lg: 20,
                      xl: 22,
                    },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Real experiences from real 990 filers - see what changed when
                  they found a smarter way to file.
                </Typography>
              </Box>

              <Grid container spacing={0} sx={{ mt: 0 }}>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                  }}
                >
                  <Box
                    component="a"
                    href="https://www.trustpilot.com/review/taxzerone.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      mt: 0,
                      display: 'inline-flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      justifyContent: 'center',
                      textAlign: 'center',
                      mx: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pr: 1.5,
                        mr: 1.5,
                        borderRight: '1px solid #e5e7eb',
                        height: 48,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 20, sm: 23 },
                          fontWeight: 600,
                          fontFamily: 'Arial, sans-serif',
                          color: '#00b67a',
                          letterSpacing: '-0.5px',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Trustpilot
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.7}
                        sx={{
                          height: 20,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          Excellent
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          4.4
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.35}
                        sx={{
                          mt: 0.6,
                        }}
                      >
                        {/* Star 1 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 2 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 3 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 4 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 5 - 40% for 4.4 rating */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            position: 'relative',
                            overflow: 'hidden',
                            backgroundColor: '#d9d9d9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {/* Grey Star */}
                          <Typography
                            sx={{
                              position: 'absolute',
                              color: '#ffffff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>

                          {/* Green 40% Star */}
                          <Box
                            sx={{
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              width: '40%',
                              height: '100%',
                              overflow: 'hidden',
                              backgroundColor: '#00b67a',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <Typography
                              sx={{
                                width: 20,
                                minWidth: 20,
                                color: '#ffffff',
                                fontSize: 14,
                                lineHeight: 1,
                                textAlign: 'center',
                              }}
                            >
                              ★
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{ border: '1px solid #ccc', borderLeft: 'unset' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/google-reviews.webp" />
                        <source srcSet="/assets/images/google-reviews.png" />
                        <Box
                          component="img"
                          src="/assets/images/google-reviews.png"
                          loading="lazy"
                          alt="Google Review"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                    borderLeft: 'unset',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/g2-logo-img.webp" />
                        <source srcSet="/assets/images/g2-logo-img.png" />
                        <Box
                          component="img"
                          src="/assets/images/g2-logo-img.png"
                          loading="lazy"
                          alt="G2 logo"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        No tax background, no problem. TaxZerone guided our
                        church through the 990-EZ step by step - zero
                        rejections, zero stress.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Pastor James
                      </Typography>
                    </Paper>

                    {/* <Paper
                            elevation={0}
                            sx={{
                              p: 3,
                              borderRadius: '16px',
                              backgroundColor: '#E0F2FE', // Light blue fill
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#334155',
                                lineHeight: 1.6,
                                fontSize: '14px',
                                mb: 2,
                              }}
                            >
                              The phone support team was really patient and walked me
                              through everything step by step. I had no tax knowledge
                              at all going in. TaxZerone made the whole process feel
                              easy and gave me confidence. 10/10.
                            </Typography>
                            <Rating
                              value={5}
                              readOnly
                              size="small"
                              sx={{ color: '#64748B', mb: 1.5 }}
                            />
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: 700,
                                color: '#0F172A',
                                fontSize: '15px',
                              }}
                            >
                              Elizabeth Wagner
                            </Typography>
                          </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#e2dafc',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        I handle 990 filings for over 20 nonprofits every year.
                        TaxZerone is the only platform that never lets me down
                        at the deadline.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Kevin S
                      </Typography>
                    </Paper>
                    {/* 
                          <Paper
                            elevation={0}
                            sx={{
                              p: 3,
                              borderRadius: '16px',
                              border: '1px solid #E2E8F0',
                              backgroundColor: '#ffffff',
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#475569',
                                lineHeight: 1.6,
                                fontSize: '14px',
                                mb: 2,
                              }}
                            >
                              Really good chat support experience. I wasn&apos;t sure
                              how to complete a few steps, but Kevin guided me clearly
                              and stayed with me until everything was done. Appreciate
                              the help.
                            </Typography>
                            <Rating
                              value={5}
                              readOnly
                              size="small"
                              sx={{ color: '#64748B', mb: 1.5 }}
                            />
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: 700,
                                color: '#0F172A',
                                fontSize: '15px',
                              }}
                            >
                              Joseph J Perez
                            </Typography>
                          </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Our private foundation needed 990-PF support. TaxZerone
                        handled it perfectly - and the support team was there
                        every step of the way!!!!!!
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Michael
                      </Typography>
                    </Paper>

                    {/* <Paper
                            elevation={0}
                            sx={{
                              p: 3,
                              borderRadius: '16px',
                              backgroundColor: '#FEF3C7', // Light yellow fill
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#334155',
                                lineHeight: 1.6,
                                fontSize: '14px',
                                mb: 2,
                              }}
                            >
                              OMG! I cannot believe how wonderful the live support
                              was. The agent Alexia assisted me with everything I
                              needed and fixed all the issues in the most professional
                              and friendly manner. Amazing customer experience. Thank
                              You!
                            </Typography>
                            <Rating
                              value={5}
                              readOnly
                              size="small"
                              sx={{ color: '#64748B', mb: 1.5 }}
                            />
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontWeight: 700,
                                color: '#0F172A',
                                fontSize: '15px',
                              }}
                            >
                              Luis Echenique
                            </Typography>
                          </Paper> */}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: {
              xs: 24,
              sm: 28,
              md: 34,
              lg: 42,
              xl: 48,
            },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          The smarter way to file your Form 990 - trusted
          <br /> by top-ranked organizations
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: 16,
              sm: 18,
              md: 18,
              lg: 20,
              xl: 22,
            },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Step-by-step guidance, automatic validation, and a multi-EIN <br />
          dashboard - all set before your deadline hits.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=best-form-990-software`}
          >
            Get Started for Free
          </Button>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={{ color: '#f3f3f3' }}>✓ No subscription</Typography>
            <Typography sx={{ color: '#f3f3f3' }}>✓ Pay per file</Typography>
            <Typography sx={{ color: '#f3f3f3' }}>✓ U.S. support</Typography>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          py: 2,
        }}
        spacing={0}
        m={0}
        component="section"
        aria-labelledby="best-990-faq"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2, md: 2 } }}
          >
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              mt={{ xs: 2, sm: 1 }}
              mb={2}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                Frequently Asked Questions
              </Typography>

              <Box
                component="div"
                sx={{ mb: 0 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                {/* Question 1 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What is the best software to file Form 990?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        TaxZerone is our top recommendation for most nonprofits
                        in 2026. It covers all 990 variants, offers strong error
                        validation, and provides transparent, affordable pricing
                        for filers of every size.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Question 2 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Can I file Form 990 online?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        Yes. TaxZerone and the other platforms compared here are
                        IRS-authorized e-file providers. The IRS now requires
                        electronic filing for most tax-exempt organizations.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Question 3 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What is the difference between Form 990, 990-EZ, and 990-N?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        Form 990-N is for small nonprofits with gross receipts
                        of $50,000 or less. Form 990-EZ covers receipts below
                        $200,000 and assets below $500,000. Form 990 is for
                        larger organizations, and Form 990-PF is for private
                        foundations regardless of size.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default BestForm990Software;
